import type Auth from '@salesforce/commerce-sdk-react/auth';
import { bffGet } from '../bff';
import type { Customer } from '../customers/model';

export async function getCustomer(authContext: Auth) {
    const authData = await authContext.ready();
    if (authData.customer_type === 'guest') {
        return {
            customerId: authData.customer_id,
            authType: 'guest',
        };
    }

    return bffGet<Customer>(`/customers/${authData.customer_id}`, {
        httpParams: [],
        accessToken: authData.access_token,
        customerId: authData.customer_id,
    });
}
